<template>
  <v-flex class="apio__panel">
    <v-card class="apio__panel-inner" outlined>
      <img alt src="img/brand/apio-symbol.svg" />
      <div class="font-48px pb-2 white--text apio__panel--apio-text">apio</div>
      <div class="h2 pb-2 white--text">Connecting Commerce</div>
      <div class="h3 font-weight-semi-bold mb-8 apioshade3--text">Take control of your integrations</div>
      <div class="white--text">Don’t have an account?</div>
      <apio-button
        button-size="small"
        button-type="get-started"
        class="apio__panel--get-started"
        @click="getStarted"
        >Get started</apio-button
      >
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "LoginBlurb",
  components: {
    ApioButton: () => import("@/components/Misc/Button.vue"),
  },
  methods: {
    getStarted() {
      this.$router.push("/pages/login?section=registration");
    },
  },
};
</script>

<style lang="scss" scoped>

.theme--light.v-sheet--outlined, .theme--dark.v-sheet--outlined {
  background-color: rgba(0, 0, 0, 0.35) !important;
}

.v-sheet.v-card {
  border-radius: 0;
  height: 576px;

  @media only screen and (max-width: 763px) {
    height: 373px;
    padding: 20px 20px;
    width: calc(100vw);
  }
}

.h3 {
  font-weight: normal;
  color: var(--apio-shade-2);
  margin-bottom: 40px;
}

.h1 {
  color: var(--apio-shade-2);
  margin-bottom: 8px;
}

::v-deep .v-sheet--outlined {
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.apio {
  &__panel{
    width: 384px;
    height: 576px;
    border-radius: 0;

    &--apio-text {
      font-weight: var(--font-extra-bold);
    }

    @media (max-width: 768px) {
      width: calc(100vw);
    }

    &--get-started {
      margin-top: 12px;
      width: 100px;
      text-transform: none;
    }

    &-mobile {
      width: calc(100vw);
      height: 393px;
      display: inline-flex;
      align-items: center;
      padding: 0 !important;
      margin: 0 !important;

      &-inner {
        display: flex;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.35) !important;
        padding: 0 !important;
        margin: 0 !important;
        height: 393px !important;
        width: 100%;
      }
    }

    &-inner {
      display: flex;
      flex-direction: column;
      background-color: rgba(0, 0, 0, 0.35);

      @media only screen and (max-width: 763px) {
        height: 393px;
        padding: 0 20px;
        width: 100%;
      }
    }
  }
}
</style>